import React from 'react';
import { createSvgIcon } from '@mui/material';

export const MiscellaneousIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_14536" data-name="Group 14536" transform="translate(-24 54)">
      <path
        id="pending_FILL0_wght400_GRAD0_opsz48_1_"
        data-name="pending_FILL0_wght400_GRAD0_opsz48 (1)"
        d="M85.118-867.625a1.318,1.318,0,0,0,.973-.4,1.334,1.334,0,0,0,.4-.976,1.318,1.318,0,0,0-.4-.973,1.335,1.335,0,0,0-.976-.4,1.318,1.318,0,0,0-.973.4,1.335,1.335,0,0,0-.4.976,1.319,1.319,0,0,0,.4.973,1.335,1.335,0,0,0,.976.4Zm5.885,0a1.318,1.318,0,0,0,.973-.4,1.334,1.334,0,0,0,.4-.976,1.318,1.318,0,0,0-.4-.973,1.335,1.335,0,0,0-.976-.4,1.318,1.318,0,0,0-.973.4,1.335,1.335,0,0,0-.4.976,1.319,1.319,0,0,0,.4.973A1.335,1.335,0,0,0,91-867.625Zm5.857,0a1.318,1.318,0,0,0,.973-.4,1.334,1.334,0,0,0,.4-.976,1.318,1.318,0,0,0-.4-.973,1.335,1.335,0,0,0-.976-.4,1.318,1.318,0,0,0-.973.4,1.335,1.335,0,0,0-.4.976,1.319,1.319,0,0,0,.4.973A1.335,1.335,0,0,0,96.861-867.625ZM91.007-858a10.648,10.648,0,0,1-4.276-.866,11.181,11.181,0,0,1-3.5-2.365,11.17,11.17,0,0,1-2.365-3.5A10.668,10.668,0,0,1,80-869.014a10.668,10.668,0,0,1,.866-4.281,11.007,11.007,0,0,1,2.365-3.488,11.292,11.292,0,0,1,3.5-2.351A10.668,10.668,0,0,1,91.014-880a10.669,10.669,0,0,1,4.281.866,11.123,11.123,0,0,1,3.488,2.351,11.108,11.108,0,0,1,2.351,3.492,10.693,10.693,0,0,1,.866,4.283,10.648,10.648,0,0,1-.866,4.276,11.235,11.235,0,0,1-2.351,3.495,11.106,11.106,0,0,1-3.493,2.365A10.641,10.641,0,0,1,91.007-858Zm.006-1.65a8.981,8.981,0,0,0,6.614-2.736,9.049,9.049,0,0,0,2.722-6.628,9.013,9.013,0,0,0-2.717-6.614A9.015,9.015,0,0,0,91-878.35a9.042,9.042,0,0,0-6.614,2.717A8.992,8.992,0,0,0,81.65-869a9.01,9.01,0,0,0,2.736,6.614A9.026,9.026,0,0,0,91.014-859.65ZM91-869Z"
        transform="translate(-55 827)"
      />
      <g id="Group_14534" data-name="Group 14534" transform="translate(24 -54)">
        <rect
          id="Rectangle_5302"
          data-name="Rectangle 5302"
          width="24"
          height="24"
          fill="none"
        />
      </g>
    </g>
  </svg>,
  'MiscellaneousIcon',
);
